import axios from "axios";


function getFondos() {
    return axios.get('api/compensacion/getprestaciones').then(r => r.data).catch(r => r);
}

function getInfoFondos(data) {
    return axios.post(`api/pago-fondo/getInfo`, data).then(r => r.data).catch(r => r);
}

function getInfoFondosAjuste(data) {
    return axios.post(`api/pago-fondo/getInfoFondosAjuste`, data).then(r => r.data).catch(r => r);
}

function saveFondosPend(data) {
    return axios.post(`api/pago-fondo/saveFondosPend`, data).then(r => r.data).catch(r => r);
}

function devolverFondo(data) {
    return axios.post(`api/pago-fondo/devolverFondo`, data).then(r => r.data).catch(r => r);
}


function editarFondo(data) {
    return axios.put(`api/pago-fondo/editarFondo`, data).then(r => r.data).catch(r => r);
}

export {
    getFondos,
    getInfoFondos,
    saveFondosPend,
    devolverFondo,
    getInfoFondosAjuste,
    editarFondo
}
